import React, { useState } from "react";
import { api } from "../../lib/api";

/**
 * NewsletterForm — small email-capture used on the Robotics landing page.
 * POSTs to /api/robotics/newsletter. On success, shows an inline confirmation
 * and clears the field. Errors surface as a short warm message.
 */
export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  async function onSubmit(e) {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setStatus({ state: "err", msg: "Please enter a valid email address." });
      return;
    }
    setStatus({ state: "loading", msg: "" });
    try {
      await api.post("/robotics/newsletter", { email });
      setStatus({ state: "ok", msg: "You're on the list. See you at launch." });
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Something went wrong. Try again later.";
      setStatus({ state: "err", msg: String(detail) });
    }
  }

  return (
    <form className="rbx-form" onSubmit={onSubmit} data-testid="rbx-newsletter-form">
      <label className="rbx-label" htmlFor="rbx-newsletter-email">Newsletter</label>
      <div className="rbx-form__row">
        <input
          id="rbx-newsletter-email"
          className="rbx-input"
          type="email"
          placeholder="your@email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status.state === "loading"}
          data-testid="rbx-newsletter-email"
        />
        <button
          type="submit"
          className="rbx-btn rbx-btn--primary"
          disabled={status.state === "loading"}
          data-testid="rbx-newsletter-submit"
          style={{ flex: "0 1 auto" }}
        >
          {status.state === "loading" ? "Sending…" : "Notify me"}
        </button>
      </div>
      {status.msg ? (
        <p
          className={`rbx-form__msg ${status.state === "ok" ? "rbx-form__msg--ok" : "rbx-form__msg--err"}`}
          data-testid="rbx-newsletter-msg"
        >
          {status.msg}
        </p>
      ) : null}
    </form>
  );
}
